import { createContext, useReducer, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

const initialState = {
  user: null,
  token: null,
};

function authReducer(state, action) {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
      };
    case 'LOGOUT':
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      return { user: null, token: null };
    case 'REGISTER': // 👈 handles both cases the same way
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
      };
    default:
      return state;
  }
}

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const [loading, setLoading] = useState(true);

  // Initialize auth from localStorage with safe parsing
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      const storedToken = localStorage.getItem('token');

      if (
        storedUser && storedUser !== 'undefined' &&
        storedToken && storedToken !== 'undefined'
      ) {
        const user = JSON.parse(storedUser);
        dispatch({
          type: 'LOGIN',
          payload: {
            user,
            token: storedToken,
          },
        });
      }
    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }

    setLoading(false); // done initializing
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, dispatch, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
